import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    usersAdminControllerListUsersV1: build.query<
      UsersAdminControllerListUsersV1ApiResponse,
      UsersAdminControllerListUsersV1ApiArg
    >({
      query: () => ({ url: `/api/v1/admin/users` }),
    }),
    usersAdminControllerListStatusesV1: build.query<
      UsersAdminControllerListStatusesV1ApiResponse,
      UsersAdminControllerListStatusesV1ApiArg
    >({
      query: () => ({ url: `/api/v1/admin/users/status-list` }),
    }),
    usersAdminControllerGetUserV1: build.query<
      UsersAdminControllerGetUserV1ApiResponse,
      UsersAdminControllerGetUserV1ApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/admin/users/${queryArg.id}` }),
    }),
    usersAdminControllerUpdateUserV1: build.mutation<
      UsersAdminControllerUpdateUserV1ApiResponse,
      UsersAdminControllerUpdateUserV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/users/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateUserBody,
      }),
    }),
    usersAdminControllerBlockUserV1: build.mutation<
      UsersAdminControllerBlockUserV1ApiResponse,
      UsersAdminControllerBlockUserV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/users/${queryArg.id}/block`,
        method: 'POST',
      }),
    }),
    usersAdminControllerUnblockUserV1: build.mutation<
      UsersAdminControllerUnblockUserV1ApiResponse,
      UsersAdminControllerUnblockUserV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/users/${queryArg.id}/unblock`,
        method: 'POST',
      }),
    }),
    usersAdminControllerResetUserMfaV1: build.mutation<
      UsersAdminControllerResetUserMfaV1ApiResponse,
      UsersAdminControllerResetUserMfaV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/users/${queryArg.id}/reset-mfa`,
        method: 'POST',
      }),
    }),
    usersAdminControllerConfirmUserEmailV1: build.mutation<
      UsersAdminControllerConfirmUserEmailV1ApiResponse,
      UsersAdminControllerConfirmUserEmailV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/users/${queryArg.id}/confirm-email`,
        method: 'POST',
      }),
    }),
    usersAdminControllerSetRolesV1: build.mutation<
      UsersAdminControllerSetRolesV1ApiResponse,
      UsersAdminControllerSetRolesV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/users/${queryArg.id}/roles`,
        method: 'PUT',
        body: queryArg.setRolesBody,
      }),
    }),
    usersAdminControllerAssignRoleByIdV1: build.mutation<
      UsersAdminControllerAssignRoleByIdV1ApiResponse,
      UsersAdminControllerAssignRoleByIdV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/users/${queryArg.id}/roles/${queryArg.roleId}`,
        method: 'POST',
      }),
    }),
    usersAdminControllerUnassignRoleByIdV1: build.mutation<
      UsersAdminControllerUnassignRoleByIdV1ApiResponse,
      UsersAdminControllerUnassignRoleByIdV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/users/${queryArg.id}/roles/${queryArg.roleId}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type UsersAdminControllerListUsersV1ApiResponse =
  /** status 200 Returns the list of users */ ListUsersResponse;
export type UsersAdminControllerListUsersV1ApiArg = void;
export type UsersAdminControllerListStatusesV1ApiResponse =
  /** status 200 Returns the list of user statuses */ ListStatusesResponse;
export type UsersAdminControllerListStatusesV1ApiArg = void;
export type UsersAdminControllerGetUserV1ApiResponse =
  /** status 200 Returns user details */ GetUserResponse;
export type UsersAdminControllerGetUserV1ApiArg = {
  id: number;
};
export type UsersAdminControllerUpdateUserV1ApiResponse =
  /** status 200 Returns updated user details */ UpdateUserResponse;
export type UsersAdminControllerUpdateUserV1ApiArg = {
  id: number;
  updateUserBody: UpdateUserBody;
};
export type UsersAdminControllerBlockUserV1ApiResponse =
  /** status 200 Returns user details with updated status */ BlockUserResponse;
export type UsersAdminControllerBlockUserV1ApiArg = {
  id: number;
};
export type UsersAdminControllerUnblockUserV1ApiResponse =
  /** status 200 Returns user details with updated status */ UnblockUserResponse;
export type UsersAdminControllerUnblockUserV1ApiArg = {
  id: number;
};
export type UsersAdminControllerResetUserMfaV1ApiResponse =
  /** status 200 Returns user details with updated status */ ResetUserMfaResponse;
export type UsersAdminControllerResetUserMfaV1ApiArg = {
  id: number;
};
export type UsersAdminControllerConfirmUserEmailV1ApiResponse =
  /** status 200 Returns user details with updated status */ ConfirmUserEmailResponse;
export type UsersAdminControllerConfirmUserEmailV1ApiArg = {
  id: number;
};
export type UsersAdminControllerSetRolesV1ApiResponse =
  /** status 200 Returns user details with updated roles */ SetRolesResponse;
export type UsersAdminControllerSetRolesV1ApiArg = {
  id: number;
  setRolesBody: SetRolesBody;
};
export type UsersAdminControllerAssignRoleByIdV1ApiResponse =
  /** status 200 Returns user details with updated roles */ AssignRoleByIdResponse;
export type UsersAdminControllerAssignRoleByIdV1ApiArg = {
  id: number;
  roleId: number;
};
export type UsersAdminControllerUnassignRoleByIdV1ApiResponse =
  /** status 200 Returns user details with updated roles */ UnassignRoleByIdResponse;
export type UsersAdminControllerUnassignRoleByIdV1ApiArg = {
  id: number;
  roleId: number;
};
export type ListUsersResponse = {
  /** User ID */
  id: number;
  /** User email address */
  email: string;
  /** CRC32 of the email (alternative user id) */
  crc: number;
  /** Full name */
  fullname: string;
  /** Company name */
  company: string;
  /** User's Telegram chat ID or null */
  telegramChatID: null | string;
  /** User status (-1: error/invalid, 0: disabled, 1: new, 2: email confirmed, 3: active user with setted 2FA) */
  status: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Human-readable user status label */
  statusLabel?: string;
  roles: {
    /** Role ID */
    id: number;
    /** Role name */
    name: string;
  }[];
}[];
export type ListStatusesResponse = {
  id: number;
  name: string;
  description: string;
}[];
export type GetUserResponse = {
  /** User ID */
  id: number;
  /** User email address */
  email: string;
  /** CRC32 of the email (alternative user id) */
  crc: number;
  /** Full name */
  fullname: string;
  /** Company name */
  company: string;
  /** User's Telegram chat ID or null */
  telegramChatID: null | string;
  /** User status (-1: error/invalid, 0: disabled, 1: new, 2: email confirmed, 3: active user with setted 2FA) */
  status: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Human-readable user status label */
  statusLabel?: string;
  roles: {
    /** Role ID */
    id: number;
    /** Role name */
    name: string;
  }[];
};
export const getUserResponseFullnamePattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']{0,}(?: [a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']*){0,4}$/;
export const getUserResponseCompanyPattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9()/&\-.,' ]{0,254}$/;
export type UpdateUserResponse = {
  /** User ID */
  id: number;
  /** User email address */
  email: string;
  /** CRC32 of the email (alternative user id) */
  crc: number;
  /** Full name */
  fullname: string;
  /** Company name */
  company: string;
  /** User's Telegram chat ID or null */
  telegramChatID: null | string;
  /** User status (-1: error/invalid, 0: disabled, 1: new, 2: email confirmed, 3: active user with setted 2FA) */
  status: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Human-readable user status label */
  statusLabel?: string;
  roles: {
    /** Role ID */
    id: number;
    /** Role name */
    name: string;
  }[];
};
export const updateUserResponseFullnamePattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']{0,}(?: [a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']*){0,4}$/;
export const updateUserResponseCompanyPattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9()/&\-.,' ]{0,254}$/;
export type UpdateUserBody = {
  /** Full name */
  fullname?: string;
  /** Company name */
  company?: string;
};
export const updateUserBodyFullnamePattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']{0,}(?: [a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']*){0,4}$/;
export const updateUserBodyCompanyPattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9()/&\-.,' ]{0,254}$/;
export type BlockUserResponse = {
  /** User ID */
  id: number;
  /** User email address */
  email: string;
  /** CRC32 of the email (alternative user id) */
  crc: number;
  /** Full name */
  fullname: string;
  /** Company name */
  company: string;
  /** User's Telegram chat ID or null */
  telegramChatID: null | string;
  /** User status (-1: error/invalid, 0: disabled, 1: new, 2: email confirmed, 3: active user with setted 2FA) */
  status: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Human-readable user status label */
  statusLabel?: string;
  roles: {
    /** Role ID */
    id: number;
    /** Role name */
    name: string;
  }[];
};
export const blockUserResponseFullnamePattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']{0,}(?: [a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']*){0,4}$/;
export const blockUserResponseCompanyPattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9()/&\-.,' ]{0,254}$/;
export type UnblockUserResponse = {
  /** User ID */
  id: number;
  /** User email address */
  email: string;
  /** CRC32 of the email (alternative user id) */
  crc: number;
  /** Full name */
  fullname: string;
  /** Company name */
  company: string;
  /** User's Telegram chat ID or null */
  telegramChatID: null | string;
  /** User status (-1: error/invalid, 0: disabled, 1: new, 2: email confirmed, 3: active user with setted 2FA) */
  status: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Human-readable user status label */
  statusLabel?: string;
  roles: {
    /** Role ID */
    id: number;
    /** Role name */
    name: string;
  }[];
};
export const unblockUserResponseFullnamePattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']{0,}(?: [a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']*){0,4}$/;
export const unblockUserResponseCompanyPattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9()/&\-.,' ]{0,254}$/;
export type ResetUserMfaResponse = {
  /** User ID */
  id: number;
  /** User email address */
  email: string;
  /** CRC32 of the email (alternative user id) */
  crc: number;
  /** Full name */
  fullname: string;
  /** Company name */
  company: string;
  /** User's Telegram chat ID or null */
  telegramChatID: null | string;
  /** User status (-1: error/invalid, 0: disabled, 1: new, 2: email confirmed, 3: active user with setted 2FA) */
  status: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Human-readable user status label */
  statusLabel?: string;
  roles: {
    /** Role ID */
    id: number;
    /** Role name */
    name: string;
  }[];
};
export const resetUserMfaResponseFullnamePattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']{0,}(?: [a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']*){0,4}$/;
export const resetUserMfaResponseCompanyPattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9()/&\-.,' ]{0,254}$/;
export type ConfirmUserEmailResponse = {
  /** User ID */
  id: number;
  /** User email address */
  email: string;
  /** CRC32 of the email (alternative user id) */
  crc: number;
  /** Full name */
  fullname: string;
  /** Company name */
  company: string;
  /** User's Telegram chat ID or null */
  telegramChatID: null | string;
  /** User status (-1: error/invalid, 0: disabled, 1: new, 2: email confirmed, 3: active user with setted 2FA) */
  status: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Human-readable user status label */
  statusLabel?: string;
  roles: {
    /** Role ID */
    id: number;
    /** Role name */
    name: string;
  }[];
};
export const confirmUserEmailResponseFullnamePattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']{0,}(?: [a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']*){0,4}$/;
export const confirmUserEmailResponseCompanyPattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9()/&\-.,' ]{0,254}$/;
export type SetRolesResponse = {
  /** User ID */
  id: number;
  /** User email address */
  email: string;
  /** CRC32 of the email (alternative user id) */
  crc: number;
  /** Full name */
  fullname: string;
  /** Company name */
  company: string;
  /** User's Telegram chat ID or null */
  telegramChatID: null | string;
  /** User status (-1: error/invalid, 0: disabled, 1: new, 2: email confirmed, 3: active user with setted 2FA) */
  status: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Human-readable user status label */
  statusLabel?: string;
  roles: {
    /** Role ID */
    id: number;
    /** Role name */
    name: string;
  }[];
};
export const setRolesResponseFullnamePattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']{0,}(?: [a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']*){0,4}$/;
export const setRolesResponseCompanyPattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9()/&\-.,' ]{0,254}$/;
export type SetRolesBody = {
  roles: {
    /** Role ID */
    roleId?: number;
    /** Role name */
    roleName?: string;
  }[];
};
export type AssignRoleByIdResponse = {
  /** User ID */
  id: number;
  /** User email address */
  email: string;
  /** CRC32 of the email (alternative user id) */
  crc: number;
  /** Full name */
  fullname: string;
  /** Company name */
  company: string;
  /** User's Telegram chat ID or null */
  telegramChatID: null | string;
  /** User status (-1: error/invalid, 0: disabled, 1: new, 2: email confirmed, 3: active user with setted 2FA) */
  status: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Human-readable user status label */
  statusLabel?: string;
  roles: {
    /** Role ID */
    id: number;
    /** Role name */
    name: string;
  }[];
};
export const assignRoleByIdResponseFullnamePattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']{0,}(?: [a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']*){0,4}$/;
export const assignRoleByIdResponseCompanyPattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9()/&\-.,' ]{0,254}$/;
export type UnassignRoleByIdResponse = {
  /** User ID */
  id: number;
  /** User email address */
  email: string;
  /** CRC32 of the email (alternative user id) */
  crc: number;
  /** Full name */
  fullname: string;
  /** Company name */
  company: string;
  /** User's Telegram chat ID or null */
  telegramChatID: null | string;
  /** User status (-1: error/invalid, 0: disabled, 1: new, 2: email confirmed, 3: active user with setted 2FA) */
  status: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Human-readable user status label */
  statusLabel?: string;
  roles: {
    /** Role ID */
    id: number;
    /** Role name */
    name: string;
  }[];
};
export const unassignRoleByIdResponseFullnamePattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']{0,}(?: [a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9\-.,']*){0,4}$/;
export const unassignRoleByIdResponseCompanyPattern =
  /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F0-9()/&\-.,' ]{0,254}$/;
